import { Model } from 'vuex-orm';

import Category from '../category/model';
import User from '../user/model';

export default class Pto extends Model {
  static entity = 'ptos';

  static fields() {
    return {
      id: this.attr(null),
      user_id: this.attr(null),
      category_id: this.attr(null),
      status: this.attr(''),
      starts_at: this.attr(''),
      ends_at: this.attr(''),
      rejected_at: this.attr(''),
      approved_at: this.attr(''),
      created_at: this.attr(''),
      updated_at: this.attr(''),
      requested_offdays: this.attr(''),
      category: this.belongsTo(Category, 'category_id'),
      user: this.belongsTo(User, 'user_id'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/pto/model.js